// extracted by mini-css-extract-plugin
export default {"ActivitiesProgress_container":"styles_ActivitiesProgress_container__Lbmc2","header":"styles_header__vGc4f","title":"styles_title__iCHKE"};